/* @flow */

import { textColor } from 'plugin/light/style/color';
import {
  antialiasing,
  listReset,
} from 'src/shared/app/base/style/token/helper';

/*
 |------------------------------------------------------------------------------
 | Styles
 |------------------------------------------------------------------------------
 */

export default {
  root: {
    margin: [40, 0, 20],
  },
  list: {
    extend: listReset,

    display: 'flex',
    flexWrap: 'wrap',
  },
  item: {
    margin: [0, 20, 10, 0],
  },
  label: {
    fontStyle: 'italic',
    textAlign: 'center',
  },
  swatch: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: 200,
    height: 80,
    padding: [20],

    fontWeight: 700,
  },
  info: {
    marginTop: 8,

    fontSize: 12,

    '& dd': {
      display: 'inline',

      '&:after': {
        content: "':'",

        display: 'inline-block',

        marginRight: 4,
      },
    },
    '& dt': {
      display: 'inline',

      marginTop: 4,

      color: textColor,

      fontSize: 'inherit',
    },
  },
  original: {
    '& $swatch': {
      backgroundColor: ({ originalColor }: Object) => originalColor,
    },
  },
  title: {
    '& $swatch': {
      border: ['solid', 1, 'currentColor'],
      color: ({ aaLargeColor }: Object) => aaLargeColor,

      fontSize: 24,
      fontWeight: 500,
    },
  },
  text: {
    '& $swatch': {
      border: ['solid', 1, 'currentColor'],
      color: ({ aaColor }: Object) => aaColor,
    },
  },
  text2: {
    '& $swatch': {
      backgroundColor: ({ lightColor }: Object) => lightColor,
      border: ['solid', 1, 'currentColor'],
      color: ({ aaLightColor }: Object) => aaLightColor,
    },
  },
  bg: {
    '& $swatch': {
      extend: ({ readableColor }: Object) =>
        readableColor === '#fff' ? antialiasing : {},

      backgroundColor: ({ originalColor }: Object) => originalColor,
      color: ({ readableColor }: Object) => readableColor,
    },
  },
  bg2: {
    '& $swatch': {
      extend: ({ altReadableColor }: Object) =>
        altReadableColor === '#fff' ? antialiasing : {},

      backgroundColor: ({ altColor }: Object) => altColor,
      color: ({ altReadableColor }: Object) => altReadableColor,
    },
  },
};
